export const SHOW_SEARCH_FIELD = 'SHOW_SEARCH_FIELD'
export const HIDE_SEARCH_FIELD = 'HIDE_SEARCH_FIELD'
export const SHOW_FILTER_LIST = 'SHOW_FILTER_LIST'
export const HIDE_FILTER_LIST = 'HIDE_FILTER_LIST'
export const SET_SELECTED_FILTER = 'SET_SELECTED_FILTER'
export const TOGGLE_TITLE = 'TOGGLE_TITLE'
export const SET_SELECTED_MENU_ITEM = 'SET_SELECTED_MENU_ITEM'
export const REMOVE_MENU_ITEM = 'REMOVE_MENU_ITEM'
export const ADD_MENU_ITEM = 'ADD_MENU_ITEM'
